import React from "react";
import LegalContent from "../../components/common/LegalContent";

export default function CancellationRefundPolicy() {
  return <LegalContent type="cancellation" />;
}
